export { PartnerOrganizationService } from '../../services/partner-organization.service';
